import React from "react"

import { Skeleton } from "@/components/ui/skeleton"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { formatDate } from "@/lib/utils"

import type { Company } from "@boundless/bl-api-client/customer/models"

function CompanyTableStructure({ children }: { children: React.ReactNode }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Company</TableHead>
          <TableHead>Last Modified</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>{children}</TableBody>
    </Table>
  )
}

export function CompanyTable({ companies }: { companies: Company[] }) {
  if (!companies.length) {
    return (
      <CompanyTableStructure>
        <TableRow className="h-10">
          <TableCell colSpan={2} className="text-muted-foreground">
            {"You don't have any companies yet"}
          </TableCell>
        </TableRow>
      </CompanyTableStructure>
    )
  }

  return (
    <CompanyTableStructure>
      {companies.map((company) => (
        <TableRow key={company.uuid} className="h-10">
          <TableCell>{company.legalName}</TableCell>
          <TableCell className="w-40">
            {formatDate(company.lastModifiedAt)}
          </TableCell>
        </TableRow>
      ))}
    </CompanyTableStructure>
  )
}

export function FallbackCompanyTable() {
  return (
    <CompanyTableStructure>
      {Array.from({ length: 3 }).map((_, i) => (
        <TableRow key={i}>
          <TableCell>
            <Skeleton className="h-6" />
          </TableCell>
          <TableCell className="w-40">
            <Skeleton className="h-6" />
          </TableCell>
        </TableRow>
      ))}
    </CompanyTableStructure>
  )
}
